"use client";
import { usePathname } from "next/navigation";
import TopBar from "./Bar";
import Header from "./Header";
import { useState } from "react";

export default function Nav() {
  const pathname = usePathname()?.replace("/en", "").replace("/ar", "");
  const [show, setShow] = useState(false);

  const isHome = pathname === `/en` || pathname === `/ar` || pathname === ``;
  const isAuth = pathname.includes("/auth");

  if (isAuth) {
    return null;
  }

  return (
    <nav className={`${isHome ? "absolute" : "sticky"} z-20 w-full`}>
      <TopBar isHome={isHome} show={show} setShow={setShow} />
      <Header isHome={isHome} setShow={setShow} />
    </nav>
  );
}
